import { render, staticRenderFns } from "./ModalImagePreview.vue?vue&type=template&id=04be7a2d"
import script from "./ModalImagePreview.vue?vue&type=script&lang=js"
export * from "./ModalImagePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports